import "core-js/modules/es6.string.small";
import "core-js/modules/es6.string.small";
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { typography, spacing } from '../../style/theme';
import { getFontSize } from '../../utils/helpers';
var USPText = styled.p.withConfig({
  displayName: "Text__USPText",
  componentId: "sc-1osdo3h-0"
})(["", " color:", ";margin-bottom:", "px;@media only screen and (max-width:", "px){font-size:", "rem;line-height:2.4rem;}"], getFontSize(typography.medium), function (_ref) {
  var theme = _ref.theme;
  return theme.color || null;
}, spacing.c * 3, spacing.collapseMenuWidth, typography.small);
USPText.propTypes = {
  children: PropTypes.node.isRequired
};
export default USPText;